import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";

const EditSupervisor = ({ open, onClose, supervisor, onSave }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_no: "",
  });

  const [errors, setErrors] = useState({});
// ✅ Name: only alphabets (2–10 chars)
const nameRegex = /^[A-Za-z]{2,20}$/;

// ✅ Email
 const emailRegex =
  /^(?!.*\.\.)[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

// ✅ Phone: starts 6–9, total 10 digits
const phoneRegex = /^[6-9]\d{9}$/;


 useEffect(() => {
  if (open && supervisor) {
    setFormData({
      first_name: supervisor.first_name || "",
      last_name: supervisor.last_name || "",
      email: supervisor.email || "",
      phone_no: supervisor.phone_no || "",
    });

    setErrors({}); // ✅ also clear errors
  }
}, [open, supervisor]);

 const handleChange = (e) => {
  let { name, value } = e.target;

  // ✅ First & Last name → only alphabets
  if (name === "first_name" || name === "last_name") {
    value = value.replace(/[^A-Za-z]/g, "");
  }

  // ✅ Email → remove starting spaces
  if (name === "email") {
  value = value
    .replace(/^\s+/, "")     // remove starting spaces
    .replace(/\.{2,}/g, "."); // prevent multiple dots
}

  // ✅ Phone → only digits, max 10
  if (name === "phone_no") {
    value = value.replace(/\D/g, "").slice(0, 10);
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  // ✅ Real-time validation
  let error = "";

  if (name === "first_name" || name === "last_name") {
    if (value && !nameRegex.test(value)) {
      error = "Only alphabets (2–20), no spaces";
    }
  }

  if (name === "email") {
  if (value.length > 50) {
    error = "Email must not exceed 50 characters";
  } else if (value.length >= 2 && !emailRegex.test(value)) {
    error = "Invalid email format";
  }
}
  if (name === "phone_no") {
    if (value && !phoneRegex.test(value)) {
      error = "Must start from 6–9 and be 10 digits";
    }
  }

  setErrors((prev) => ({
    ...prev,
    [name]: error,
  }));
};
const validateForm = () => {
  const tempErrors = {};

  const firstName = formData.first_name.trim();
  const lastName = formData.last_name.trim();
  const email = formData.email.trim();
  const phone = formData.phone_no.trim();

  // ✅ First Name
  if (!firstName) {
    tempErrors.first_name = "First name is required";
  } else if (!nameRegex.test(firstName)) {
    tempErrors.first_name =
      "Only alphabets, min 2, max 20 char , no spaces";
  }

  // ✅ Last Name
  if (!lastName) {
    tempErrors.last_name = "Last name is required";
  } else if (!nameRegex.test(lastName)) {
    tempErrors.last_name =
      "Only alphabets, min 2 ,max 10 char, no spaces";
  }

 // ✅ Email
if (!email) {
  tempErrors.email = "Email is required";
} else if (email.length < 2 || email.length > 50) {
  tempErrors.email = "Email must be between 2 and 50 characters";
} else if (!emailRegex.test(email)) {
  tempErrors.email = "Invalid email format";
}

  // ✅ Phone
  if (!phone) {
    tempErrors.phone_no = "Phone number is required";
  } else if (!phoneRegex.test(phone)) {
    tempErrors.phone_no =
      "Must start from 6–9 and be 10 digits";
  }

  setErrors(tempErrors);
  return Object.keys(tempErrors).length === 0;
};

useEffect(() => {
  if (!open) {
    setErrors({});
  }
}, [open]);


 const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const payload = { ...formData };
      await apiService.post(`/api/update_supervisors/${supervisor.user_id}/`, payload);
      
      toast.success("Supervisor updated successfully!"); // ✅ Only success here
      onSave({ ...supervisor, ...formData });
      onClose();
    } catch (error) {
      console.error("Update Error:", error);
      toast.error(error.response?.data?.error || "Something went wrong"); // ✅ Only error here
    }
  };

  // if (!open) return null;

  return (
  <>
    {open && (
      <div className="edit-site-modal">
        <Box
          component="form"
          className="edit-site-container edit-site-form"
          onSubmit={handleSubmit}
        >
          <Typography className="edit-site-title">
            Edit Supervisor
          </Typography>

          <TextField
            label="First Name"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            error={!!errors.first_name}
            helperText={errors.first_name}
          />

          <TextField
            label="Last Name"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            error={!!errors.last_name}
            helperText={errors.last_name}
          />

          <TextField
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === " ") e.preventDefault();
            }}
            error={!!errors.email}
            helperText={errors.email}
          />

          <TextField
            label="Phone Number"
            name="phone_no"
            value={formData.phone_no}
            onChange={handleChange}
            error={!!errors.phone_no}
            helperText={errors.phone_no}
          />

          <div className="edit-btn-wrapper">
            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>

            <button type="submit" className="edit-btn">
              Save Changes
            </button>
          </div>
        </Box>
      </div>
    )}

    <ToastContainer
      position="top-right"
      autoClose={3000}
      theme="light"
    />
  </>
);
};

export default EditSupervisor;